exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nh1.page-title[data-v-38551b2e] {\n  color: #fff;\n  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\n  font-size: 2em;\n  font-weight: 400;\n  margin-bottom: 15px;\n}\nh3.page-title[data-v-38551b2e] {\n  color: #fff;\n  text-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);\n}\n.donate__wrapper[data-v-38551b2e] {\n  margin: 20px 0 0;\n}\n.donate__wrapper button[data-v-38551b2e] {\n    width: 100%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38551b2e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/templates/products/phapa.vue
// module id = 578
// module chunks = 1